<template>
  <div class="tracking-stage">
    <div class="stage-header" v-bind:class="{ 
        'first-stage': stage=='1',
        'stage-status-completed': stage_status=='completed',
        'stage-status-pending': stage_status=='pending',
        'stage-status-disabled': stage_status=='disabled',
      }">{{title}}
    </div>
    <div class="grid-wrapper">
      <TrackingCell
        v-for="cell in cells"
        v-bind:stage="stage"
        v-bind:key="cell.id"
        v-bind:id="cell.id"
        v-bind:icon="cell.icon"
        v-bind:text="cell.text"
        v-bind:name="cell.name"
        v-bind:modified="cell.modified"
        v-bind:status="cell.status"
        v-bind:line_horizontal="cell.line_horizontal"
        v-bind:line_vertical="cell.line_vertical"
      >
      </TrackingCell>
    </div>
  </div>



</template>

<script>
import TrackingCell from '@/components/containerViews/containerTrackingComponents/TrackingCell'

export default {
  name: 'TrackingStage',
  components: {
    TrackingCell
  },
  props: ['stage', 'title', 'cells'],
  data(){
    return {
      stage_status: 'disabled'
    }
  },
}
</script>

<style lang= "scss" scoped>
.tracking-stage {
  margin-bottom: 30px;
  position: relative;
}
.grid-wrapper {
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  grid-gap: 0px;
  width: 100%;
}
.stage-header {
  width: 100%;
  background-color: #05a8d1;
  color: white;
  padding: 2px;
  display:flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85em;
  font-weight: 600;
}
.first-stage {
  margin-top: 50px;
}
.stage-status-completed {
  background-color: #32AC91;
}
.stage-status-pending {
  background-color: #00B1FF;
}
.stage-status-disabled {
  background-color: #D0D0D0;
}
</style>
